import * as profileTypes from './profileTypes';
import { fetchProfileName, fetchProfileDetail } from 'src/services/profile.service';

export const getProfileName = profileId => {
  return async dispatch => {
    // dispatch(isLoading(profileTypes.LOADING_PROFILE, true));
    await fetchProfileName(profileId)
      .then(res => {
        if (res && !res.error) {
          dispatch(getProfileNameSuccess(res));
          // dispatch(isLoading(profileTypes.LOADING_PROFILE, false));
        } else {
          // dispatch(isLoading(profileTypes.LOADING_PROFILE, false));
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const getProfileDetail = profileId => {
  return async dispatch => {
    dispatch(isLoading(profileTypes.LOADING_PROFILE, true));
    await fetchProfileDetail(profileId)
      .then(res => {
        if (res && !res.error) {
          dispatch(getProfileDetailSuccess(res));
          dispatch(isLoading(profileTypes.LOADING_PROFILE, false));
        } else {
          dispatch(isLoading(profileTypes.LOADING_PROFILE, false));
          throw new Error(res.error.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const toggleProfileDetailLoading = showLoading => {
  return async dispatch => {
    dispatch(isLoading(profileTypes.LOADING_PROFILE, !!showLoading));
  };
};

export const getProfileNameSuccess = payload => {
  return {
    type: profileTypes.GET_PROFILE_NAME_SUCCESS,
    payload,
  };
};

export const getProfileDetailSuccess = payload => {
  return {
    type: profileTypes.GET_PROFILE_DETAIL_SUCCESS,
    payload,
  };
};

const isLoading = (type, isLoading) => {
  return {
    type,
    isLoading,
  };
};

export default {
  getProfileDetail,
  toggleProfileDetailLoading,
};
